import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '../shared.global-service';
import { formatNumber } from '@libs/shared/utils/format-number';

@Pipe({
    name: 'formatOfferUnitPrice',
})

export class FormatOfferUnitPricePipe implements PipeTransform {
    transform(offer: {
        unit?: string | null,
        unitPrice?: string | null,
        unitPriceExt?: string | null
    }, priceType: 'basic' | 'ext' = 'basic'): string {
        return formatOfferUnitPrice(offer, priceType);
    }
}

export function formatOfferUnitPrice(offer: {
    unit?: string | null,
    unitPrice?: string | null,
    unitPriceExt?: string | null
}, priceType: 'basic' | 'ext' = 'basic'): string {
    if (!offer.unit) return '';
    if (!offer.unitPrice && priceType === 'basic') return '';
    if (!offer.unitPriceExt && priceType === 'ext') return '';

    const price = priceType === 'ext' ? offer.unitPriceExt : offer.unitPrice;

    return `${formatNumber(Number(price), 2, true)} Kč / ${translate.instant(`enum.measurementUnitPrice.${offer.unit}`)}`;
}
